import React from 'react';
import {constants} from '@neosvoc/nv-platform-core-common';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Icon from '../../Icon';
import {Rating, RatingBattery} from '../../icons';
import {get} from 'lodash';

const icons = {
    [constants.EDITOR_TEMPLATES.BATTERY_1]: 'batteria',
    [constants.EDITOR_TEMPLATES.BATTERY_2]: 'batteria',
    [constants.EDITOR_TEMPLATES.DATE_1]: 'data',
    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_1]: 'risposta-multipla',
    [constants.EDITOR_TEMPLATES.MULTIPLE_CHOICE_2]: 'scelta-immagine',
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_1]: 'differenziale-semantico',
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2]: 'scala-ad-intervalli', // TODO
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_3]: 'chart-pie', // TODO
    [constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_4]: <RatingBattery />, // multiple_number_2 con componentType 'rating'
    [constants.EDITOR_TEMPLATES.RANK_1]: 'ranking', // TODO
    [constants.EDITOR_TEMPLATES.NUMBER_1]: 'variabile-cardinale',
    [constants.EDITOR_TEMPLATES.NUMBER_2]: 'scala-ad-intervalli',
    [constants.EDITOR_TEMPLATES.NUMBER_3]: <Rating />, // number_2 con componentType 'rating'
    [constants.EDITOR_TEMPLATES.RATING_1]: <Rating />, // TODO
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1]: 'variabile-nominale',
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_2]: 'variabile-ordinale',
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_3]: 'scala_likert',
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_4]: 'scelta-immagine',
    [constants.EDITOR_TEMPLATES.STRING_1]: 'variabile-aperta',
    [constants.EDITOR_TEMPLATES.TEXT_1]: 'testo',
    [constants.EDITOR_TEMPLATES.SINGLE_CHOICE_1_EXT]: 'variabile-nominale', // TODO
    [constants.EDITOR_TEMPLATES.IMAGE_1]: 'scelta-immagine', // TODO
    [constants.EDITOR_TEMPLATES.GEO_1]: ['fas', 'map-marked-alt'], // TODO
    [constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER]: ['far', 'object-group'], // TODO
    [constants.EDITOR_TEMPLATES.FOLDER]: 'folder', // TODO
    [constants.EDITOR_TEMPLATES.BACK]: 'back', // TODO
    [constants.EDITOR_TEMPLATES.GENERATOR_CLASSIFIER_2]: ['far', 'object-group'], // TODO

};

const TypeIcon = ({type, style, item, ...props}) => {
    let icon;
    if (get(item, 'componentType') === undefined) {
        icon = icons[type];
    } else {
        if (type === constants.EDITOR_TEMPLATES.NUMBER_2) {
            if (item.componentType === 'rating') icon = icons[constants.EDITOR_TEMPLATES.RATING_1];
            if (item.componentType === 'slider') icon = icons[constants.EDITOR_TEMPLATES.NUMBER_2];
        }
        if (type === constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2) {
            if (item.componentType === 'rating') icon = icons[constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_4];
            if (item.componentType === 'slider') icon = icons[constants.EDITOR_TEMPLATES.MULTIPLE_NUMBER_2];
        }
    }

    if (icon && Array.isArray(icon)) {
        return <FontAwesomeIcon className="icon-fa" icon={icon} style={style} />;
    }

    if (icon && React.isValidElement(icon)) {
        return React.cloneElement(icon, {style, ...props});
    }
    return <Icon icon={icon} style={style} {...props} />;
};

export default TypeIcon;
